/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty */
/* eslint-disable max-len */
/* eslint-disable no-eval */
/* eslint-disable nordic/i18n-jsx-no-literals */
/* eslint-disable-next-line no-restricted-globals */
const React = require('react');
const { useLiveDemoContext } = require('../base-live-demo-component/Provider/liveDemoContext');
const { brickCreationScript, allPaymentMethods, allPaymentTypes } = require('./constants');

const View = ({
  publicKey,
  valueProp,
  color,
  backgroundColor,
  showMercadoPagoLogo,
  paymentMethods,
  paymentTypes,
  maxInstallments,
  interestFreeInstallments,
  contentAlign,
  borderColor,
  border,
  borderWidth,
  borderRadius,
  verticalPadding,
  horizontalPadding,
  align,
  useCustomFont,
  size,
  fontWeight,
  language,
}) => {
  const { setBehaviorData } = useLiveDemoContext();

  React.useEffect(() => {
    window.brandBricksProps = {
      publicKey: publicKey || 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b',
      text: {
        valueProp: valueProp || 'payment_methods',
        align: align || 'left',
        useCustomFont: useCustomFont || false,
        size: size || 'medium',
        fontWeight: fontWeight || 'semibold',
        color: color || 'secondary',
      },
      paymentMethods: {
        excludedPaymentMethods: allPaymentMethods?.filter((method) => !paymentMethods.includes(method)) || [],
        excludedPaymentTypes: allPaymentTypes?.filter((type) => !paymentTypes.includes(type)) || [],
        maxInstallments: maxInstallments || 12,
        interestFreeInstallments: interestFreeInstallments || false,
      },
      visual: {
        backgroundColor: backgroundColor || 'white',
        hideMercadoPagoLogo: !showMercadoPagoLogo || false,
        border: border || false,
        borderColor: borderColor || 'dark',
        contentAlign: contentAlign || 'center',
        borderWidth: `${borderWidth}px` || '1px',
        borderRadius: `${borderRadius}px` || '0px',
        verticalPadding: `${verticalPadding}px` || '8px',
        horizontalPadding: `${horizontalPadding}px` || '16px',
      },
      language: language || 'es-AR',
    };

    setTimeout(() => {
      setBehaviorData(prev => ({
        ...prev,
        showLayoutSpinner: false,
      }));
      window.eval(brickCreationScript);
    }, 1000);
  }, [
    publicKey,
    valueProp,
    color,
    backgroundColor,
    showMercadoPagoLogo,
    paymentMethods,
    paymentTypes,
    maxInstallments,
    interestFreeInstallments,
    contentAlign,
    borderColor,
    border,
    borderWidth,
    borderRadius,
    verticalPadding,
    horizontalPadding,
    align,
    useCustomFont,
    size,
    fontWeight,
    language,
  ]);

  React.useEffect(() => {
    const mpScript = document.createElement('script');
    mpScript.src = 'https://sdk.mercadopago.com/js/v2';
    document.body.appendChild(mpScript);
    return () => {
      document.body.removeChild(mpScript);
    };
  }, []);

  addEventListener('brandBrickReady', () => {
    setBehaviorData(prev => ({
      ...prev,
      showLayoutSpinner: false,
    }));
  });

  return (
    <>
      <div className={`brand-brick-form__main-container${[backgroundColor, color].includes('white') ? '--dark' : ''}`}>
        <div className="brand-brick-banner-container">
          <div id="brandBrick_container" />
        </div>
        <div className="brand-brick-form__white-field" />
        <div className="brand-brick-form__white-field" />
        <div className="brand-brick-form__two-columns">
          <div className="brand-brick-form__white-field" />
          <div className="brand-brick-form__divisor" />
          <div className="brand-brick-form__white-field" />
        </div>
        <div className="brand-brick-form__dark-field" />
      </div>
    </>
  );
};

module.exports = View;
